module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-30.e20425d9.jpg";